var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 12.3307L15.5663 13.772C16.1446 14.3503 16.1446 15.288 15.5663 15.8663C14.9879 16.4446 14.0503 16.4446 13.4719 15.8663L12.0307 14.4251M1 7.67505C1 4.15423 3.85418 1.30005 7.37499 1.30005C10.8958 1.30005 13.75 4.15423 13.75 7.67505C13.75 11.1959 10.8958 14.05 7.37499 14.05C3.85418 14.05 1 11.1959 1 7.67505Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/SearchGrey.d22b431080fe376d2762786ba64ad9fa.svg";
export { ForwardRef as ReactComponent };